import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

import ItemService from "../../../services/supplier_appCommonService";
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import ConfirmationLoader from "../../../Components/ConfirmationLoader";
import { formatDateTime } from "../../../common/Validations";

const inspectionTypeData = [
  { id: 1, name: "Final Inspection" },
  { id: 2, name: "Incoming Inspection" },
  { id: 3, name: "In-Process Inspection" },
  { id: 4, name: "Pre-Shipment Inspection" },
  { id: 5, name: "Random Sampling" },
];

const overallResultData = [
  { id: 1, name: "Pass" },
  { id: 2, name: "Fail" },
  { id: 3, name: "Conditional" },
];

const inspectionMethodData = [
  { id: 1, name: "Visual Inspection" },
  { id: 2, name: "Dimensional Check" },
  { id: 3, name: "Functional Test" },
  { id: 4, name: "Chemical Analysis" },
  { id: 5, name: "Destructive Testing" },
  { id: 6, name: "Non-Destructive Testing" },
];

const samplingMethodData = [
  { id: 1, name: "Random Sampling" },
  { id: 2, name: "Stratified Sampling" },
  { id: 3, name: "Systematic Sampling" },
  { id: 4, name: "100% Inspection" },
];

const itemResultData = [
  { id: 1, name: "Pass" },
  { id: 2, name: "Fail" },
  { id: 3, name: "Conditional" },
];

const CreateQualityCheck = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Create Quality Check");

  let grnNumber = useSelector(
    (state) => state?.qualityCheck?.quality_check?.grnNumber
  );

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [grnData, setGrnData] = useState(null);
  const [poData, setPoData] = useState(null);
  const [itemTableData, setItemTableData] = useState([]);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);

  const toggleCardVisibility1 = () => setCardVisible1(!isCardVisible1);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
  const toggleCardVisibility4 = () => setCardVisible4(!isCardVisible4);
  const toggleCardVisibility5 = () => setCardVisible5(!isCardVisible5);
  const toggleCardVisibility6 = () => setCardVisible6(!isCardVisible6);
  const toggleCardVisibility7 = () => setCardVisible7(!isCardVisible7);

  const [formInputs, setFormInputs] = useState({
    grnNr: "",
    purchasingDocumentNr: "",
    vendorCode: "",
    vendorName: "",
    inspectionDate: new Date().toISOString().split("T")[0],
    inspectorName: "",
    inspectionType: "Final Inspection",
    overallResult: "",
    inspectionComments: "",
    qualityCheckStatus: "Created",
    inspectionQuantity: "",
    acceptedQuantity: "",
    rejectedQuantity: "",
    qualityScore: "",
    inspectionMethod: "Visual Inspection",
    inspectionNotes: "",
    defectDescription: "",
    correctiveAction: "",
    approvalStatus: "Pending",
    approvedBy: "",
    approvalDate: "",
    approvalComments: "",
    qualityReportNr: "",
    certificateOfConformity: "",
    samplingMethod: "Random Sampling",
    sampleSize: "",
    testEquipmentUsed: "",
    temperatureCondition: "",
    humidityCondition: "",
    otherConditions: "",
  });

  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState({ title: "Message", successMsg: "" });
  const [getNextNavigate, setNextNavigate] = useState("");

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => ({ ...prev, [name]: value }));
  };

  const onItemInputChange = (local_id, fieldName, value) => {
    setItemTableData((prev) =>
      prev.map((item) => {
        if (item.local_id === local_id) {
          const updated = { ...item, [fieldName]: value };
          if (fieldName === "acceptedQuantity" || fieldName === "inspectionQuantity") {
            const accepted = Number(fieldName === "acceptedQuantity" ? value : item.acceptedQuantity) || 0;
            const inspected = Number(fieldName === "inspectionQuantity" ? value : item.inspectionQuantity) || 0;
            if (inspected > 0) {
              updated.qualityScore = Math.round((accepted / inspected) * 100);
            } else {
              updated.qualityScore = 0;
            }
          }
          return updated;
        }
        return item;
      })
    );
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((prev) => ({ ...prev, [data.fieldName]: data.attachmentId }));
  };

  useEffect(() => {
    if (grnNumber) {
      loadGRNDetails();
    }
    // eslint-disable-next-line
  }, [grnNumber]);

  const loadGRNDetails = async () => {
    setLoading(true);
    try {
      let obj = { grnNr: grnNumber };
      const res = await ItemService.getGRNDetailsForQualityCheck(obj);
      if (res?.status === 200 && res.data) {
        let grn = res.data.grn || res.data;
        let po = res.data.po || null;
        if (Array.isArray(res.data) && res.data.length > 0) {
          grn = res.data[0]?.grn || res.data[0];
          po = res.data[0]?.po || null;
        }
        setGrnData(grn);
        setPoData(po);
        setFormInputs((prev) => ({
          ...prev,
          grnNr: grn?.grnNr || "",
          purchasingDocumentNr: grn?.purchasingDocumentNr || "",
          vendorCode: grn?.vendorCode || po?.vendorCode || "",
          vendorName: grn?.vendorName || po?.vendorName || "",
        }));
        const items = grn?.items || [];
        const mappedItems = items.map((item, index) => ({
          ...item,
          local_id: index + 1,
          inspectionQuantity: Number(item.grnQuantity) || 0,
          acceptedQuantity: "",
          rejectedQuantity: "",
          qualityScore: "",
          inspectionNotes: "",
          defectDescription: "",
          itemResult: "",
        }));
        setItemTableData(mappedItems);
      } else {
        toast.error(res?.message || "GRN not found");
      }
    } catch (err) {
      console.log("Error loading GRN:", err);
      toast.error("Error loading GRN details");
    }
    setLoading(false);
  };

  const handleSubmit = async () => {
    if (!formInputs.inspectorName) {
      toast.error("Please enter Inspector Name");
      return;
    }
    if (!formInputs.overallResult) {
      toast.error("Please select Overall Result");
      return;
    }
    const totalAccepted = itemTableData.reduce((sum, item) => sum + (Number(item.acceptedQuantity) || 0), 0);
    const totalRejected = itemTableData.reduce((sum, item) => sum + (Number(item.rejectedQuantity) || 0), 0);
    const totalInspected = itemTableData.reduce((sum, item) => sum + (Number(item.inspectionQuantity) || 0), 0);
    const overallScore = totalInspected > 0 ? Math.round((totalAccepted / totalInspected) * 100) : 0;

    formInputs.items = itemTableData;
    formInputs.inspectionQuantity = totalInspected;
    formInputs.acceptedQuantity = totalAccepted;
    formInputs.rejectedQuantity = totalRejected;
    formInputs.qualityScore = overallScore;
    formInputs.qualityCheckStatus = "Created";
    formInputs.overallScore = overallScore;

    const toastId = toast.loading("Creating Quality Check...", { position: "top-right" });
    setDisabled(true);
    try {
      let obj = { data: formInputs };
      const res = await ItemService.addQualityCheck(obj);
      if (res?.status === 200) {
        setsucceModalData({ title: "Success", successMsg: res.message || "Quality Check created successfully" });
        setShowSuccessModal(true);
        setNextNavigate(Constants.POCOLLABRATION_QUALITY_CHECK_LIST);
      } else {
        toast.error(res?.message || "Failed to create Quality Check");
      }
    } catch (err) {
      console.log("Error creating quality check:", err);
      toast.error("Error creating Quality Check");
    }
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
    if (getNextNavigate) navigate(getNextNavigate);
  };

  const itemColumns = [
    { name: "Item Nr", selector: (row) => row.grnItemNr || row.local_id, width: "80px" },
    { name: "Material", selector: (row) => row.materialCode || "-", width: "120px" },
    { name: "Description", selector: (row) => row.materialDescription || "-", width: "180px" },
    { name: "GRN Qty", selector: (row) => row.grnQuantity || "-", width: "100px" },
    {
      name: "Inspected Qty",
      cell: (row) => (
        <InputField type="number" className="inputBox form-control-sm" name="inspectionQuantity"
          value={row.inspectionQuantity} onChange={(e) => onItemInputChange(row.local_id, "inspectionQuantity", e.target.value)} />
      ),
      width: "120px",
    },
    {
      name: "Accepted Qty",
      cell: (row) => (
        <InputField type="number" className="inputBox form-control-sm" name="acceptedQuantity"
          value={row.acceptedQuantity} onChange={(e) => onItemInputChange(row.local_id, "acceptedQuantity", e.target.value)} />
      ),
      width: "120px",
    },
    {
      name: "Rejected Qty",
      cell: (row) => (
        <InputField type="number" className="inputBox form-control-sm" name="rejectedQuantity"
          value={row.rejectedQuantity} onChange={(e) => onItemInputChange(row.local_id, "rejectedQuantity", e.target.value)} />
      ),
      width: "120px",
    },
    {
      name: "Score",
      cell: (row) => (
        <span className={row.qualityScore >= 80 ? "text-success fw-bold" : row.qualityScore >= 50 ? "text-warning fw-bold" : "text-danger fw-bold"}>
          {row.qualityScore || "-"}%
        </span>
      ),
      width: "80px",
    },
    {
      name: "Result",
      cell: (row) => (
        <select
          className="form-select form-select-sm inputBox"
          value={row.itemResult || ""}
          onChange={(e) => {
            setItemTableData((prev) =>
              prev.map((item) =>
                item.local_id === row.local_id ? { ...item, itemResult: e.target.value } : item
              )
            );
          }}
        >
          <option value="">Select</option>
          {itemResultData.map((opt) => (
            <option key={opt.id} value={opt.name}>{opt.name}</option>
          ))}
        </select>
      ),
      width: "140px",
    },
    {
      name: "Defect Notes",
      cell: (row) => (
        <InputField className="inputBox form-control-sm" name="defectDescription" value={row.defectDescription}
          onChange={(e) => onItemInputChange(row.local_id, "defectDescription", e.target.value)} placeholder="Defect details" />
      ),
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <ConfirmationLoader isPageLoading={loading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Quality Check Creation</h2>
            <p className="subText">Create new Quality Check/Inspection Record against GRN: <strong>{grnNumber}</strong></p>
            <hr />

            {/* ============ SECTION 1: Inspection Header ============ */}
            <div className="accordion mb-4" id="qcAccordion1">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility1}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IH</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Inspection Header</span>
                      <span className="subHeaderTitle">Inspection Details and Overall Result</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Inspection Date" name="inspectionDate" type="date"
                          value={formInputs.inspectionDate} onChange={onInputChange} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Inspector Name" name="inspectorName"
                          value={formInputs.inspectorName} onChange={onInputChange} placeholder="Enter Inspector Name" required={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Inspection Type</label>
                        <select className="form-select inputBox" name="inspectionType" value={formInputs.inspectionType} onChange={onInputChange}>
                          {inspectionTypeData.map((opt) => (
                            <option key={opt.id} value={opt.name}>{opt.name}</option>
                          ))}
                        </select>
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Overall Result <span style={{color:'red'}}>*</span></label>
                        <select className="form-select inputBox" name="overallResult" value={formInputs.overallResult} onChange={onInputChange}>
                          <option value="">Select Overall Result</option>
                          {overallResultData.map((opt) => (
                            <option key={opt.id} value={opt.name}>{opt.name}</option>
                          ))}
                        </select>
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Quality Check Status" name="qualityCheckStatus"
                          value={formInputs.qualityCheckStatus} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Inspection Comments" name="inspectionComments"
                          value={formInputs.inspectionComments} onChange={onInputChange} rows={3} placeholder="Enter inspection comments" />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 2: Purchase Order Details ============ */}
            <div className="accordion mb-4" id="qcAccordion2">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility2}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PO</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Purchase Order Details</span>
                      <span className="subHeaderTitle">PO Information from GRN</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="PO Number" value={formInputs.purchasingDocumentNr} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="PO Date" value={(grnData && grnData.purchasingDocumentDate) || (poData && poData.purchasingDocumentDate) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="PO Value" value={(grnData && grnData.purchasingDocumentValue) || (poData && poData.purchasingDocumentValue) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Currency" value={(grnData && grnData.currencyCode) || (poData && poData.currencyCode) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Payment Terms" value={(grnData && grnData.paymentTerms) || (poData && poData.paymentTerms) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Inco Terms" value={(grnData && grnData.incoTerms) || (poData && poData.incoTerms) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Vendor Code" value={formInputs.vendorCode} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Vendor Name" value={formInputs.vendorName} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 3: GRN/Receipt Details ============ */}
            <div className="accordion mb-4" id="qcAccordion3">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility3}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GR</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">GRN/Receipt Details</span>
                      <span className="subHeaderTitle">Goods Receipt Note Information</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Number" value={formInputs.grnNr} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Date" value={grnData ? (formatDateTime(grnData.createdAt) || grnData.grnDate || "-") : "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Delivery Date" value={(grnData && grnData.deliveryDate) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Value" value={(grnData && grnData.sumOfGrn) || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Status" value={(grnData && grnData.grnStatusHeader) || "-"} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 4: Item/Line Details ============ */}
            <div className="accordion mb-4" id="qcAccordion4">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility4}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IL</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Item/Line Details</span>
                      <span className="subHeaderTitle">GRN Line Items Inspection</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable columns={itemColumns} data={itemTableData} pagination={false} noDataComponent="No items found in GRN" striped />
                      </Col>
                    </Row>
                    <Row className="pt-2 pb-4 mt-3">
                      <Col xs={12} md={3} lg={3} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Total Inspected"
                          value={itemTableData.reduce((s, i) => s + (Number(i.inspectionQuantity) || 0), 0)} disabled={true} />
                      </Col>
                      <Col xs={12} md={3} lg={3} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Total Accepted"
                          value={itemTableData.reduce((s, i) => s + (Number(i.acceptedQuantity) || 0), 0)} disabled={true} />
                      </Col>
                      <Col xs={12} md={3} lg={3} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Total Rejected"
                          value={itemTableData.reduce((s, i) => s + (Number(i.rejectedQuantity) || 0), 0)} disabled={true} />
                      </Col>
                      <Col xs={12} md={3} lg={3} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Overall Score"
                          value={itemTableData.reduce((s, i) => s + (Number(i.acceptedQuantity) || 0), 0) + " / " + itemTableData.reduce((s, i) => s + (Number(i.inspectionQuantity) || 0), 0)} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 5: Inspection/QC Inputs ============ */}
            <div className="accordion mb-4" id="qcAccordion5">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility5}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QI</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Inspection/QC Inputs</span>
                      <span className="subHeaderTitle">Quality Control Methods and Conditions</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Inspection Method</label>
                        <select className="form-select inputBox" name="inspectionMethod" value={formInputs.inspectionMethod} onChange={onInputChange}>
                          {inspectionMethodData.map((opt) => (
                            <option key={opt.id} value={opt.name}>{opt.name}</option>
                          ))}
                        </select>
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Sampling Method</label>
                        <select className="form-select inputBox" name="samplingMethod" value={formInputs.samplingMethod} onChange={onInputChange}>
                          {samplingMethodData.map((opt) => (
                            <option key={opt.id} value={opt.name}>{opt.name}</option>
                          ))}
                        </select>
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Sample Size" name="sampleSize" type="number"
                          value={formInputs.sampleSize} onChange={onInputChange} placeholder="Enter sample size" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Test Equipment Used" name="testEquipmentUsed"
                          value={formInputs.testEquipmentUsed} onChange={onInputChange} placeholder="e.g. Calipers, Micrometer" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Temperature Condition" name="temperatureCondition"
                          value={formInputs.temperatureCondition} onChange={onInputChange} placeholder="e.g. 25C" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Humidity Condition" name="humidityCondition"
                          value={formInputs.humidityCondition} onChange={onInputChange} placeholder="e.g. 60%" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Other Conditions" name="otherConditions"
                          value={formInputs.otherConditions} onChange={onInputChange} placeholder="Any other conditions" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Inspection Notes" name="inspectionNotes"
                          value={formInputs.inspectionNotes} onChange={onInputChange} rows={3} placeholder="Detailed inspection notes" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Defect Description" name="defectDescription"
                          value={formInputs.defectDescription} onChange={onInputChange} rows={3} placeholder="Describe any defects found" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Corrective Action" name="correctiveAction"
                          value={formInputs.correctiveAction} onChange={onInputChange} rows={3} placeholder="Corrective actions taken or recommended" />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 6: Documents ============ */}
            <div className="accordion mb-4" id="qcAccordion6">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility6}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible6 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DO</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Documents</span>
                      <span className="subHeaderTitle">Reports, Certificates and Attachments</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Quality Report Number" name="qualityReportNr"
                          value={formInputs.qualityReportNr} onChange={onInputChange} placeholder="Quality Report Nr" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Certificate of Conformity" name="certificateOfConformity"
                          value={formInputs.certificateOfConformity} onChange={onInputChange} placeholder="CoC Number" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Upload Inspection Report</label>
                        <FileUploadComponent fieldName="inspectionReportAttachment" onSuccess={onSuccessUploadDocumentType} module="QualityCheck" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mt-3">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Upload Photos</label>
                        <FileUploadComponent fieldName="inspectionPhotosAttachment" onSuccess={onSuccessUploadDocumentType} module="QualityCheck" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mt-3">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Upload Test Certificates</label>
                        <FileUploadComponent fieldName="testCertificateAttachment" onSuccess={onSuccessUploadDocumentType} module="QualityCheck" />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 7: Approval/Workflow ============ */}
            <div className="accordion mb-4" id="qcAccordion7">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility7}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible7 ? "bi-chevron-right" : "bi-chevron-down"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AW</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Approval/Workflow</span>
                      <span className="subHeaderTitle">Approval Status and Workflow</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approval Status" value={formInputs.approvalStatus} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approved By" name="approvedBy"
                          value={formInputs.approvedBy} onChange={onInputChange} placeholder="Approver name" disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approval Date" name="approvalDate" type="date"
                          value={formInputs.approvalDate} onChange={onInputChange} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approval Comments" name="approvalComments"
                          value={formInputs.approvalComments} onChange={onInputChange} placeholder="Approval comments" disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Col>
      </Row>

      {/* ============ FOOTER ============ */}
      <div className="pageFooter mb-4 pb-2">
        <Row className="rowDirection">
          <Col xs={12} md={2} lg={2}>
            <button className="btnTable" onClick={handleSubmit} disabled={disabled}>
              <i className="bi bi-save"></i> Submit
            </button>
          </Col>
        </Row>
      </div>

      <SuccessModal show={getShowSuccessModal} onHide={hideSuccessModal} data={getsucceModalData} />
    </main>
  );
};

export default CreateQualityCheck;
